import { Link } from "react-router-dom";
import BrandMark from "../components/icons/BrandMark";

export default function HomePage(): JSX.Element {
    return (
        <div className="space-y-10">
            <section className="relative overflow-hidden rounded-3xl border border-[rgb(var(--border)/0.10)] bg-[rgb(var(--surface)/0.05)] p-6 shadow-sm sm:p-10">
                <div className="absolute inset-0">
                    <div className="absolute -left-24 -top-24 h-80 w-80 rounded-full bg-[rgb(var(--surface)/0.14)] blur-3xl" />
                    <div className="absolute -bottom-28 -right-28 h-80 w-80 rounded-full bg-[rgb(var(--surface)/0.08)] blur-3xl" />
                </div>

                <div className="relative grid gap-10 md:grid-cols-2 md:items-center">
                    <div className="space-y-5">
                        <div className="inline-flex items-center gap-3 rounded-2xl border border-[rgb(var(--border)/0.10)] bg-[rgb(var(--panel)/0.40)] px-4 py-3">
                            <BrandMark className="h-8 w-8" />
                            <div className="leading-tight">
                                <div className="text-sm font-semibold">
                                    Give Me A Visual
                                </div>
                                <div className="text-xs text-[rgb(var(--muted))]">
                                    Stunning visual showcases, tailored for any
                                    device.
                                </div>
                            </div>
                        </div>

                        <h1 className="text-3xl font-semibold tracking-tight sm:text-4xl">
                            The simple way to showcase anything, anywhere.
                        </h1>

                        <p className="text-sm leading-relaxed text-[rgb(var(--muted2))] sm:text-base">
                            Navigate visualizations effortlessly, dive into the
                            details, and take the next step. A clean,
                            high-performance interface designed for clarity on
                            any device.
                        </p>

                        <div className="flex flex-col gap-3 sm:flex-row">
                            <Link
                                to="/contact"
                                className="inline-flex items-center justify-center rounded-2xl border border-[rgb(var(--border)/0.15)] bg-[rgb(var(--surface)/0.05)] px-5 py-3 text-sm font-semibold text-[rgb(var(--fg))] transition hover:bg-[rgb(var(--surface)/0.10)]"
                            >
                                Contact
                            </Link>
                        </div>
                    </div>

                    <div className="grid gap-4">
                        <div className="rounded-3xl border border-[rgb(var(--border)/0.10)] bg-[rgb(var(--panel)/0.40)] p-6">
                            <div className="text-sm font-semibold">
                                Mobile-first
                            </div>
                            <div className="mt-2 text-sm text-[rgb(var(--muted))]">
                                Designed to look sharp on phones, tablets, and
                                desktops.
                            </div>
                        </div>
                        <div className="rounded-3xl border border-[rgb(var(--border)/0.10)] bg-[rgb(var(--panel)/0.40)] p-6">
                            <div className="text-sm font-semibold">
                                Per-asset theming
                            </div>
                            <div className="mt-2 text-sm text-[rgb(var(--muted))]">
                                Apply Ocean, Ember, or Forest styling
                                automatically for a specific listing.
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="grid gap-4 md:grid-cols-3">
                <div className="rounded-2xl border border-[rgb(var(--border)/0.10)] bg-[rgb(var(--surface)/0.05)] p-5">
                    <div className="text-sm font-semibold">
                        Universal Showcases
                    </div>
                    <div className="mt-1 text-sm text-[rgb(var(--muted))]">
                        Present any asset or collection with a refined, modern
                        layout that adapts to your content.
                    </div>
                </div>
                <div className="rounded-2xl border border-[rgb(var(--border)/0.10)] bg-[rgb(var(--surface)/0.05)] p-5">
                    <div className="text-sm font-semibold">
                        Smart Exploration
                    </div>
                    <div className="mt-1 text-sm text-[rgb(var(--muted))]">
                        Powerful filtering and search tools allow users to find
                        exactly what they need in seconds.
                    </div>
                </div>
                <div className="rounded-2xl border border-[rgb(var(--border)/0.10)] bg-[rgb(var(--surface)/0.05)] p-5">
                    <div className="text-sm font-semibold">
                        Optimized Clarity
                    </div>
                    <div className="mt-1 text-sm text-[rgb(var(--muted))]">
                        A high-performance interface crafted to ensure your work
                        looks impeccable on every screen.
                    </div>
                </div>
            </section>
        </div>
    );
}
